import { subscribeToInboxTickets, type InboxTicketEvent } from './inbox-events'

const DEFAULT_HEARTBEAT_MS = 25_000
const DEFAULT_MAX_STREAM_MS = 240_000

export function createInboxEventStream({
  tenantId,
  heartbeatMs = DEFAULT_HEARTBEAT_MS,
  maxStreamMs = DEFAULT_MAX_STREAM_MS,
  subscribe = subscribeToInboxTickets,
}: {
  tenantId: string
  heartbeatMs?: number
  maxStreamMs?: number
  subscribe?: typeof subscribeToInboxTickets
}) {
  const encoder = new TextEncoder()
  let cleanup = () => {}

  const stream = new ReadableStream({
    start(controller) {
      let closed = false

      const safeEnqueue = (payload: string) => {
        if (closed) return
        try {
          controller.enqueue(encoder.encode(payload))
        } catch {
          cleanup()
        }
      }

      const unsubscribe = subscribe(tenantId, (event: InboxTicketEvent) => {
        safeEnqueue(`event: new-ticket\ndata: ${JSON.stringify(event)}\n\n`)
      })

      const heartbeat = setInterval(() => {
        safeEnqueue(': heartbeat\n\n')
      }, heartbeatMs)

      const closeTimer = setTimeout(() => {
        if (closed) return
        safeEnqueue('event: reconnect\ndata: {}\n\n')
        closed = true
        clearInterval(heartbeat)
        unsubscribe()
        controller.close()
      }, maxStreamMs)

      cleanup = () => {
        if (closed) return
        closed = true
        clearInterval(heartbeat)
        clearTimeout(closeTimer)
        unsubscribe()
      }

      safeEnqueue('event: connected\ndata: {}\n\n')
    },
    cancel() {
      cleanup()
    },
  })

  return stream
}
